<template>
    <div class="create-super-admin">
        <div class="card">
            <div class="card-body">
                <div class="left-side">
                    <h3 class="title-header">Create new user</h3>
                    <h4 class="section-header">Assign role</h4>
                    <select class="custom-select form-control" v-model="roleId" @change="getInitialPermissions()">
                        <option value="5" selected>Super Admin</option>
                        <option value="8">Support</option>
                        <option value="6">Fulfilment</option>
                        <option value="10">Sales</option>
                    </select>
                    <h4 class="title-header">User info</h4>
                    <fieldset :class="[errors && errors.has('new-user-firstname') ? 'error-field' : '']">
                        <label for="new-user-firstname">First Name</label>
                        <input type="text" id="new-user-firstname" class="form-control" v-validate="'required'" data-vv-as="New user first name" name="new-user-firstname" v-model="firstName">
                        <span v-show="errors && errors.has('new-user-firstname')" class="validate-warning">{{ errors.first('new-user-firstname') }}</span>
                    </fieldset>
                    <fieldset :class="[errors && errors.has('new-user-lastname') ? 'error-field' : '']">
                        <label for="new-user-lastname">Last Name</label>
                        <input type="text" id="new-user-lastname" class="form-control" v-validate="'required'" data-vv-as="New user last name" name="new-user-lastname" v-model="lastName">
                        <span v-show="errors && errors.has('new-user-lastname')" class="validate-warning">{{ errors.first('new-user-lastname') }}</span>
                    </fieldset>
                    <fieldset :class="[errors && errors.has('new-user-email') ? 'error-field' : '']">
                        <label for="new-user-email">Email</label>
                        <input type="text" id="new-user-email" class="form-control" v-validate="'required|email'" data-vv-as="New user email" name="new-user-email" v-model="email">
                        <span v-show="errors && errors.has('new-user-email')" class="validate-warning">{{ errors.first('new-user-email') }}</span>
                    </fieldset>
                </div>
                <div class="right-side">
                    <h3 class="title-header">Set permissions</h3>
                    <h4 class="permissions-subtitle">Company Specific</h4>
                    <div class="permissions-checkboxes">
                        <div v-for="permission of companyPermissions">
                            <div v-if="permission.code != 'ALL_COMPANIES_ACCESS'" class="permission-item">
                                <div class="checkbox-box">
                                    <FTScheckbox v-model="permission.selected" :label="permission.name"></FTScheckbox>
                                </div>
                                <div class="description">{{permission.description}}</div>
                            </div>
                            <div v-else>
                                <div class="permission-item">
                                    <div class="radio-box">
                                        <input type="radio" id="all-company-access" name="company-access" v-model="permission.selected" value="ALL_COMPANIES_ACCESS">
                                        <label for="all-company-access"><span>{{permission.name}}</span></label>
                                    </div>
                                    <div class="description">{{permission.description}}</div>
                                </div>
                                <div class="permission-item">
                                    <div class="radio-box">
                                        <input type="radio" id="company-access" name="company-access" v-model="permission.selected" value="ONLY_SELECTED_COMPANIES">
                                        <label for="company-access"><span>Company access</span></label>
                                    </div>
                                    <div class="description">User will have access to selected companies</div>
                                </div>
                                <div class="companies-select-dropdown">
                                    <div class="companies-select">
                                        <div class="fts-dropdown" v-click-outside="closeDropdownCompany">
                                            <div :class="['dropdown-control', openedDropdownCompany ? 'straight-border' : '']" @click="openCloseDropdownCompany">
                                                <span class="dropdown-title" v-if="selectedCompanies.length == 0">{{dropdownTitleCompany}}</span>
                                                <div v-else class="selected-list">
                                                    <div v-for="selected in displaySelectedCompanies" class="selected-item">
                                                        {{selected.label}}
                                                        <i class="fa fa-times-circle" @click.stop="deselectOptionCompanies(selected)"></i>
                                                    </div>
                                                </div>
                                                <span class="count-hidden">
                                                {{countHiddenCompanies}}
                                                </span>
                                                <i :class="['fa', openedDropdownCompany ? 'fa-caret-up' : 'fa-caret-down']"></i>
                                            </div>
                                            <div :class="['dropdown-list', openedDropdownCompany ? 'list-visible' : '']">
                                                <div class="dropdown-search">
                                                    <i class="fa fa-search"></i>
                                                    <input v-model="searchedPhraseCompany" type="text" placeholder="Search" @keyup="searchPhraseCompanies"/>
                                                </div>
                                                <div class="dropdown-options">
                                                    <div class="dropdown-option">
                                                        <label class="dropdown-label" :for="'company-option0'" :option-selected="isAllRowSelected()">
                                                            <input class="dropdown-checkbox" :id="'company-option0'" type="checkbox" :checked="isAllRowSelected()" @change="selectAllOptionCompany()">
                                                            <span></span>
                                                            <span class="option-content">Select All Companies</span>
                                                        </label>
                                                    </div>
                                                    <div class="dropdown-option" v-for="row in displayedCompanies">
                                                        <label class="dropdown-label" :for="'company-option' + row.value" :option-selected="row.selected">
                                                            <input class="dropdown-checkbox" :id="'company-option' + row.value" type="checkbox" :checked="row.selected" @change="selectOptionCompany(row)">
                                                            <span></span>
                                                            <span class="option-content">{{row.label}}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="clear-box">
                                                    <button class="btn btn-light clear-btn" @click="clearCompaniesDropdown">Clear</button>
                                                </div>
                                            </div>
                                        </div>
                                        <p>{{selected.companies}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 class="permissions-subtitle">Super Admin Specific</h4>
                    <div v-for="permission of adminPermissions" class="permissions-checkboxes">
                        <div class="permission-item">
                            <div class="checkbox-box">
                                <FTScheckbox v-model="permission.selected" :label="permission.name"></FTScheckbox>
                            </div>
                            <div class="description">{{permission.description}}</div>
                        </div>
                    </div>
                    <div class="control-bar">
                        <a @click="getInitialPermissions()">Reset permissions</a>
                        <div class="buttons-box">
                            <button class="btn btn-light" @click="goBackToUsersPermissions()">Cancel</button>
                            <button class="btn btn-success" @click="createSuperAdmin()">Create</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Axios from 'axios'
    import globalStore from "../../variables";
    import VeeValidate from "vee-validate";
    import Vue from "vue";
    import FTScheckbox from "../../ftsComponents/FTScheckbox";
    import VueCookies from "vue-cookies";

    const veeValidateConfig = {};

    Vue.use(VeeValidate, veeValidateConfig);
    Vue.use(VueCookies);
    Vue.$cookies.config('7d','','',true)

    export default {
        name: "CreateSuperAdmin",
        components: {
            FTScheckbox
        },
        data() {
            return {
                companiesList: [],
                displayedCompanies: [],
                searchedPhraseCompany: '',
                countHiddenCompanies: '',
                selected: {
                    companies: ''
                },
                openedDropdownCompany: false,
                selectedCompanies: [],
                displaySelectedCompanies: [],
                dropdownTitleCompany: 'Companies',
                permissions: {
                    editPaySettings: false,
                    editOtherSettings: false,
                    editCompanyAllowances: false,
                    performActionsOnCompany: false,
                    editPlanPricing: false,
                    manageCouponCodes: false,
                    errorLogsAccess: false,
                    orderManagement: false,
                    tfbQueueManagement: false,
                    superAdminReportsAccess: false,
                    billingReportsAccess: false,
                    genesisUsageAccess: false,
                    simQuery: false,
                    registrationEnrollment: false,
                    dailySalesReports: false,
                    systemHealth: false,
                    coldStockManagement: false
                },
                companiesAccess: '',
                roleId: 5,
                firstName: '',
                lastName: '',
                email: '',
                companyPermissions: [],
                adminPermissions: []
            }
        },
        methods: {
            getPermissionsList() {
                Axios.get(globalStore.data.restApiUrl + '/admin/super-admin-permissions')
                    .then(response => {
                        for (let item of response.data) {
                            if (item.permissionType == 'COMPANY_SPECIFIC') {
                                for (let permission of item.typePermissions) {
                                    if (permission.code == 'ALL_COMPANIES_ACCESS') {
                                        permission.selected = 'ALL_COMPANIES_ACCESS'
                                        this.companyPermissions.push(permission)
                                    } else {
                                        permission.selected = false
                                        this.companyPermissions.push(permission)
                                    }
                                }
                            } else if (item.permissionType == 'SUPER_ADMIN_SPECIFIC') {
                                for (let permission of item.typePermissions) {
                                    if (permission.name != 'Super Admin Panel') {
                                        permission.selected = false
                                        this.adminPermissions.push(permission)
                                    }
                                }
                            }
                        }
                        this.getInitialPermissions();
                    })
            },
            getInitialPermissions() {
                Axios.get( globalStore.data.restApiUrl + '/admin/users/permissions?roleId=' + this.roleId)
                    .then(response => {
                        this.setPermissions(response.data)
                        this.clearCompaniesDropdown();
                    })
            },
            setPermissions(permissions) {
                for (let permission of this.companyPermissions) {
                    if (permissions.indexOf(permission.code) > -1) {
                        if (permission.code == 'ALL_COMPANIES_ACCESS') {
                            permission.selected = 'ALL_COMPANIES_ACCESS'
                        } else {
                            permission.selected = true
                        }
                    } else {
                        permission.selected = false
                    }
                    if (permission.code == 'ALL_COMPANIES_ACCESS' && permission.selected != 'ALL_COMPANIES_ACCESS') {
                        permission.selected = 'ONLY_SELECTED_COMPANIES'
                    }
                }
                for (let permission of this.adminPermissions) {
                    if (permissions.indexOf(permission.code) > -1) {
                        permission.selected = true
                    } else {
                        permission.selected = false
                    }
                }
            },
            getCompaniesList() {
                Axios.get(`${globalStore.data.restApiUrl}/admin/accounts?page=1&size=1000&sort=2&desc=false`)
                    .then(response => {
                        this.companiesList = [];
                        for (let company of response.data.selectedCompanies.response) {
                            this.companiesList.push(
                                {
                                    value: company.companyId,
                                    label: company.companyName,
                                    selected: false
                                }
                            )
                        }
                        this.displayedCompanies = this.companiesList;
                    })
            },
            searchPhraseCompanies() {
                if (this.searchedPhraseCompany != '') {
                    this.displayedCompanies = this.companiesList.filter(item => {
                        return item.label.toLowerCase().indexOf(this.searchedPhraseCompany.toLowerCase()) != -1 ? item : null;
                    })
                } else {
                    this.displayedCompanies = this.companiesList;
                }
            },
            selectAllOptionCompany() {
                for (let company in this.displayedCompanies) {
                    this.selectOptionCompany(this.displayedCompanies[company])
                }
            },
            selectOptionCompany(option) {
                option.selected = !option.selected;
                if (option.selected)
                    this.selectedCompanies.push(option);
                else
                    this.selectedCompanies = this.selectedCompanies.filter(item => {
                        return option.value != item.value
                    })

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        //let countCompanies = this.selectedCompanies.length;
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);
                if (this.selectedCompanies.length > 0 && this.companiesAccess != 'ONLY_SELECTED_COMPANIES') {
                    this.companiesAccess = 'ONLY_SELECTED_COMPANIES'
                }
            },
            deselectOptionCompanies(option) {
                this.selectedCompanies = this.selectedCompanies.filter(item => {
                    return option.value != item.value
                })
                for (let item of this.companiesList) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }
                for (let item of this.displayedCompanies) {
                    if (item.value == option.value) {
                        item.selected = false;
                    }
                }

                if (this.selectedCompanies.length > 0) {
                    if (this.selectedCompanies.length == 1) {
                        this.selected.companies = '1 company selected'
                        this.countHiddenCompanies = ''
                    } else {
                        //let countCompanies = this.selectedCompanies.length;
                        this.countHiddenCompanies = '...'
                        this.selected.companies = this.selectedCompanies.length + ' companies selected'
                    }
                } else {
                    this.countHiddenCompanies = ''
                    this.selected.companies = 'None selected'
                }

                this.displaySelectedCompanies = this.selectedCompanies.slice(0,1);

            },
            clearDropdown() {
                this.tagsList.map(item => {
                    item.selected = false;
                })

                this.displayedTags.map(item => {
                    item.selected = false;
                })

                this.selectedTags = [];
                this.openedDropdown = false;
                this.selected.tags = 'None selected'
                this.countHiddenTags = ''
            },
            clearCompaniesDropdown() {
                this.companiesList.map(item => {
                    item.selected = false;
                })

                this.displayedCompanies.map(item => {
                    item.selected = false;
                })

                this.selectedCompanies = [];
                this.openedDropdownCompany = false;
                this.selected.companies = 'None selected'
                this.countHiddenCompanies = ''
            },
            openCloseDropdownCompany() {
                if (!this.openedDropdownCompany)
                    this.openedDropdownCompany = true;
                else
                    this.openedDropdownCompany = false;
            },
            closeDropdownCompany() {
                if (this.openedDropdownCompany)
                    this.openedDropdownCompany = false;
            },
            isAllRowSelected() {
                if (this.selectedCompanies.length == this.displayedCompanies.length) {
                    return true
                } else {
                    return false;
                }
            },
            goBackToUsersPermissions() {
                this.$router.push('/admin/users-permissions')
            },
            createSuperAdmin() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let parsedData = {}
                        parsedData.firstName = this.firstName
                        parsedData.lastName = this.lastName
                        parsedData.email = this.email
                        parsedData.roleId = this.roleId
                        parsedData.permissions = []

                        for (let permission of this.companyPermissions) {
                            if (permission.code != 'ALL_COMPANIES_ACCESS') {
                                if (permission.selected) {
                                    parsedData.permissions.push(permission.code)
                                }
                            } else {
                                if (permission.selected == 'ALL_COMPANIES_ACCESS') {
                                    parsedData.permissions.push(permission.code)
                                } else if (permission.selected == 'ONLY_SELECTED_COMPANIES') {
                                    parsedData.associatedCompanies = []
                                    for (let company of this.selectedCompanies) {
                                        parsedData.associatedCompanies.push(company.value)
                                    }
                                }
                            }
                        }

                        for (let permission of this.adminPermissions) {
                            if (permission.selected) {
                                parsedData.permissions.push(permission.code)
                            }
                        }


                        let roleName = ''
                        if (this.roleId == 5) {
                            roleName = 'Super Admin'
                        } else if (this.roleId == 6) {
                            roleName = 'Fulfilment'
                        } else if (this.roleId == 8) {
                            roleName = 'Support'
                        }

                        Axios.post( globalStore.data.restApiUrl + '/admin/users/new', parsedData)
                            .then(response => {
                                this.$notify({
                                    type: 'success',
                                    group: 'notification',
                                    title: 'New ' + roleName + ' account created',
                                    text: 'Account creation done successful.',
                                    duration: 5000,
                                });
                                this.goBackToUsersPermissions()
                            })
                            .catch(error => {

                                if (error.response.status != 429) {
                                    this.$notify({
                                        type: 'error',
                                        group: 'notification',
                                        title: 'New ' + roleName + ' account has not been created',
                                        text: 'Something went wrong during account creation.',
                                        duration: 5000,
                                    });
                                }
                            })
                    } else {
                        this.$notify({
                            type: 'warn',
                            group: 'notification',
                            title: 'Validation error',
                            text: 'Some fields has incorrect values.',
                            duration: 5000,
                        });
                    }
                })
            }

        },
        created() {
            this.getPermissionsList();
            this.getInitialPermissions();
            this.getCompaniesList();
        }
    }
</script>

<style lang="scss">
    .create-super-admin {
        .card {
            .card-body {
                display: flex;
                padding: 0;
                .left-side {
                    width: 400px;
                    padding: 20px 0;
                    border-right: 1px solid #c8ced3;
                    h3.title-header {
                        margin: 0 0 22px;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    h4.title-header {
                        margin: 20px 0 12px;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .section-header {
                        font-size: 15px;
                        padding: 0 20px;
                        font-weight: 400;
                    }

                    select.form-control {
                        max-width: calc(100% - 40px);
                        margin: 0 20px;
                    }

                    fieldset {
                        padding: 0 20px;
                        &.error-field {
                            .validate-warning {
                                color: #fc4d4d;
                            }
                        }
                    }
                }
                .right-side {
                    padding: 20px 0;
                    flex-grow: 1;

                    .title-header {
                        margin: 0;
                        padding: 0 20px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .permissions-subtitle {
                        padding: 0 20px;
                        margin: 30px 0 17px;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .permissions-checkboxes {
                        padding: 0 20px;
                        .permission-item {
                            display: flex;
                            align-items: center;
                            .radio-box {
                                margin: 6px 0;

                                input[type="radio"] {
                                    display: none;

                                    &:checked + label::after {
                                        content: '';
                                        display: inline-block;
                                        position: absolute;
                                        left: 4px;
                                        top: 4px;
                                        width: 8px;
                                        height: 8px;
                                        margin-right: 8px;
                                        background-color: #2F353A;
                                        border-radius: 50%;
                                    }
                                }

                                label {
                                    position: relative;
                                    display: flex;
                                    margin: 0;

                                    &::before {
                                        content: '';
                                        display: inline-block;
                                        width: 16px;
                                        height: 16px;
                                        border: 2px solid #2F353A;
                                        border-radius: 50%;
                                        margin-right: 8px;
                                    }
                                }
                            }
                            .radio-box,
                            .checkbox-box {
                                width: 200px;
                                margin-right: 50px;
                            }
                            .description {
                                color: #515B65;
                            }
                        }
                        .companies-select-dropdown {
                            margin: 20px 0 0;
                            padding: 0 20px;
                        }
                    }
                    .control-bar {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 20px 20px 0;
                        a {
                            color: #0088FF;
                            font-weight: 700;
                            cursor: pointer;
                        }
                        .buttons-box {
                            .btn {
                                &:first-child {
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    .dark-theme {
        .create-super-admin {
            .card {
                .card-body {
                    .left-side {
                        border-color: #1a1c1d;
                    }
                    .right-side {
                        .permissions-checkboxes {
                            .permission-item {
                                .radio-box {
                                    input[type="radio"]:checked {
                                        &+label {
                                            &:after {
                                                background-color: #fff;
                                            }
                                        }
                                    }
                                    label {
                                        &:before {
                                            border-color: #fff;
                                        }
                                    }
                                }
                                .description {
                                    color: #ffffff;
                                }
                            }
                        }
                        .control-bar {
                            border-color: #1a1c1d;
                        }
                    }
                }
            }
        }
    }

</style>
